import {Distance} from '../Domain/Distance';
import {GeoPoint} from '../Models/GeoPoint';

/**
 * Convert degrees to radians.
 * @param degrees The amount of degrees to convert to radians. Will return a negative result in case of a negative input.
 * @returns The amount of radians, relative to the amount of degrees given.
 */
function degreesToRadians(degrees: number): number {
    return (degrees * Math.PI) / 180;
}

/**
 * Calculate the distance between 2 GeoPoints. Takes curvature of earth into account.
 * @param geoPointA The first GeoPoint.
 * @param geoPointB The second GeoPoint.
 * @returns A Distance instance indicating the distance between the 2 points.
 */
export function distanceBetweenGeoPoints(geoPointA: GeoPoint, geoPointB: GeoPoint): Distance {
    const earthRadius = 6371; // Earth's radius in kilometers
    const latDiff = degreesToRadians(geoPointB.lat - geoPointA.lat);
    const lngDiff = degreesToRadians(geoPointB.lng - geoPointA.lng);
    const a =
        Math.sin(latDiff / 2) * Math.sin(latDiff / 2) +
        Math.cos(degreesToRadians(geoPointA.lat)) *
            Math.cos(degreesToRadians(geoPointB.lat)) *
            Math.sin(lngDiff / 2) *
            Math.sin(lngDiff / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadius * c;
    return Distance.fromKilometers(distance);
}
